import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static identifier = "anti-cheat-live-refresh"
  static targets = ["frame"]
  static values = {
    url: String,
    page: Number,
    perPage: Number,
    interval: { type: Number, default: 60000 }
  }

  connect() {
    this.boundVisibilityChange = this.handleVisibilityChange.bind(this)
    document.addEventListener("visibilitychange", this.boundVisibilityChange)

    this.refreshTimer = setInterval(() => this.refresh(), this.intervalValue)
  }

  disconnect() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }

    document.removeEventListener("visibilitychange", this.boundVisibilityChange)
  }

  handleVisibilityChange() {
    if (!document.hidden) this.refresh()
  }

  refresh() {
    if (document.hidden) return
    if (!this.hasFrameTarget || !this.urlValue) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("page", String(this.pageValue || 1))
    url.searchParams.set("per_page", String(this.perPageValue || 25))
    url.searchParams.set("_ts", String(Date.now()))

    this.frameTarget.src = url.toString()
  }
}
